/*
	JSON-stat JS Sample Code
	http://json-stat.org/tools/js.txt
	Author: Xavier Badosa (http://xavierbadosa.com)
	Date: 2015-12-22
	Version: 1.0.1

	Copyright 2015 Xavier Badosa
	License: Apache License, Version 2.0 http://www.apache.org/licenses/LICENSE-2.0
*/

export function main(obj, query) {
  //Validate jsonstat
  var jsonstat = JSONstat(obj);
  if (!jsonstat) {
    return;
  }

  //Parse: Get value from jsonstat and query
  // eslint-disable-next-line no-unused-vars
  var value = getValue(jsonstat, query);

  //Write: Display query and result
  // show( query , value );
}

//getValue() converts a dimension/category object into a data value in three steps.
//Input example: {"concept":"UNR","area":"US","year":"2010"}
//Output example: 9.627692959
function getValue(jsonstat, query) {
  //1. {"concept":"UNR","area":"US","year":"2010"} ==> [0, 33, 7]
  var indices = getDimIndices(jsonstat, query);

  //2. [0, 33, 7] ==> 403
  var index = getValueIndex(jsonstat, indices);

  //3. 403 ==> 9.627692959
  return jsonstat.value[index];
}

//getDimIndices() converts a dimension/category object into an array of dimensions' indices.
//Input example: {"concept":"UNR","area":"US","year":"2010"}
//Output example: [0, 33, 7]
function getDimIndices(jsonstat, query) {
  var dim = jsonstat.dimension,
    ids = jsonstat.id || dim.id; //JSON-stat 2.0-ready
  for (var arr = [], i = 0, len = ids.length; i < len; i++) {
    arr[i] = getDimIndex(dim, ids[i], query[ids[i]]);
  }

  return arr;
}

//getValueIndex() converts an array of dimensions' indices into a numeric value index.
//Input example: [0, 33, 7]
//Output example: 403
function getValueIndex(jsonstat, indices) {
  var size = jsonstat.size || jsonstat.dimension.size; //JSON-stat 2.0-ready

  for (var i = 0, ndims = size.length, num = 0, mult = 1; i < ndims; i++) {
    mult *= i > 0 ? size[ndims - i] : 1;
    num += mult * indices[ndims - i - 1];
  }

  return num;
}

//getDimIndex() converts a dimension ID string and a category ID string into the numeric index of that category in that dimension.
//Input example: "area", "US"
//Output example: 33
function getDimIndex(dim, name, value) {
  //In single category dimensions, "index" is optional
  if (!dim[name].category.index) {
    return 0;
  }

  var ndx = dim[name].category.index;

  //"index" can be an object or an array
  if (Object.prototype.toString.call(ndx) !== "[object Array]") {
    //Object
    return ndx[value];
  } else {
    //Array
    return ndx.indexOf(value); //Polyfill required in old browsers
  }
}

//Validate
function JSONstat(jsonstat) {
  if (!jsonstat) {
    window.alert("Error: no response could be retrieved.");
    return null;
  }

  //If no "class", "bundle" response:
  //use the first dataset available
  //(assuming single dataset bundle response)
  //[Of course, it'd be better to add an argument
  //to the function to pass a dataset ID if
  //bundle responses must be properly supported.]
  if (!jsonstat.class) {
    jsonstat = jsonstat[Object.keys(jsonstat)[0]]; //Polyfill required in old browsers
  } else {
    //Verify it's a "dataset" response
    if (jsonstat.class !== "dataset") {
      window.alert("Error: response was not a JSON-stat bundle or dataset response.");
      return null;
    }
  }

  //Program requires "value" and "dimension" properties
  if (!jsonstat.value || !jsonstat.dimension) {
    window.alert("Error: response is not valid JSON-stat or does not contain required information.");
    return null;
  }

  return jsonstat;
}

//show() displays the query and its result.
// function show( query , result ){
// 	var text="";
// 	for(var prop in query) {
// 		text+=prop + "=" + query[prop] + " ";
// 	}
// 	text+="==> " + result;

// 	document.getElementsByTagName("p")[0].innerHTML=text;
// }

// JIN custom stuff
export function groupData(apiResult, dimensionValue, action, weighting, param) {
  const { size, value, id } = apiResult;
  let groupSize = size[id.indexOf(dimensionValue)];
  let res = [];
  for (let i = 0; i < value.length; i++) {
    let tmp = res[i % groupSize] || 0;
    res[i % groupSize] = Math.round(tmp + value[i]);
  }
  if (action === "alternate-negative") {
    let a = [];
    for (let j = 0; j < res.length; j++) {
      let tmp = res[j];
      a.push(j % 2 ? Math.round(tmp * -1) : Math.round(tmp));
    }
    res = a;
  }
  if (action === "average") {
    let b = [];
    let regionName = null;
    if (id.includes("Region")) {
      regionName = "Region";
    } else if (id.includes("KOKkommuneregion0000")) {
      regionName = "KOKkommuneregion0000";
    } else if (id.includes("KOKkommuneregion0001")) {
      regionName = "KOKkommuneregion0001";
    }
    let regions = size[id.indexOf(regionName)];
    for (let i = 0; i < value.length; i++) {
      let tmp = b[i % groupSize] || 0;
      b[i % groupSize] = Math.round(tmp + value[i]);
    }
    let c = b.map((i) => {
      return Math.round(i / regions);
    });
    res = c;
  }
  if (action === "weighting") {
    const { dimension } = apiResult;
    let b = [];
    let regionName = null;
    if (id.includes("Region")) {
      regionName = "Region";
    } else if (id.includes("KOKkommuneregion0000")) {
      regionName = "KOKkommuneregion0000";
    } else if (id.includes("KOKkommuneregion0001")) {
      regionName = "KOKkommuneregion0001";
    }
    let regions = size[id.indexOf(regionName)];
    let elementsPrCity = value.length / regions;
    for (let i = 0; i < value.length; i++) {
      let tmp = b[i % groupSize] || 0;
      let regionArrayIndex = Math.floor(i / elementsPrCity);
      let cityIndexes = dimension[regionName].category.index;

      let currentCityIndex = Object.keys(cityIndexes).find((index) => cityIndexes[index] === regionArrayIndex);
      let currentCityWeighting = weighting.find((item) => item.cityIndex === currentCityIndex);
      let weightPercentage = currentCityWeighting ? currentCityWeighting.weightPercentage : 1;
      let weightedValue = value[i] * weightPercentage;
      b[i % groupSize] = Math.round(tmp + weightedValue);
    }
    if (param === "salary") {
      b = b.map((i) => Math.round(i * 12));
    }
    res = b;
  }

  if (action === "salary-gender") {
    let c = [];

    for (let i = 0; i < value.length; i++) {
      let tmp = c[i % groupSize] || 0;
      c[i % groupSize] = tmp + value[i];
    }
    let divider = value.length / groupSize;
    c[0] = Math.round((c[0] / divider) * 12);
    c[1] = Math.round((c[1] / divider) * 12);

    res = c;
  }
  return res;
}
